export type StudyStatus = 'borrador' | 'vigente' | 'revision' | 'archivado';

export interface StudyActivity {
  id: string;
  studyId: string;
  parentId: string | null;
  outlineNo: string;
  name: string;
  sortOrder: number;
  children: StudyActivity[];
}

export interface RiskStudy {
  id: string;
  code: string;
  title: string;
  orgUnitId: string;
  evaluationMethodId: string;
  status: StudyStatus;
  studyDate: string;
  orgUnit?: { id: string; name: string; kind?: string };
  evaluationMethod?: { id: string; name: string; kind?: string };
  activities?: StudyActivity[];
  _count?: { activities: number; risks: number };
}

export interface StudySummary {
  totalRisks: number;
  byLevel: Record<string, number>;
  withActionsPercent: number;
}

export interface CreateStudyPayload {
  code: string;
  title: string;
  orgUnitId: string;
  evaluationMethodId: string;
  studyDate: string;
}

export const STUDY_STATUS_LABEL: Record<StudyStatus, string> = {
  borrador: 'Borrador',
  vigente: 'Vigente',
  revision: 'En revisión',
  archivado: 'Archivado',
};
